export default __webpack_public_path__ + "static/media/Ikhlas.5ce75855.mp3";